<template>
  <div class="coupon-item" :class="[status]">
    <div class="coupon-item-body">
      <!-- 抽下组件 -->
      <div class="body-left">
        <coupon-item-left :coupon="coupon"></coupon-item-left>
      </div>
      <div class="body-right">
        <div class="coupon-info">
          <div class="coupon-reach-reduce">
            <span>{{coupon.coupon_name}}</span>
          </div>
          <div class="coupon-desc" >
            <div class="text">{{coupon.desc}}</div>
            <div class="desc-tips" @click="handleShowDescPopup" v-if="(coupon.scope === 1 && coupon.countries) || (coupon.scope === 2 && coupon.products)"></div>
          </div>
          <div class="coupon-time" v-if="coupon.start_date && coupon.end_date">
            <div class="time" v-if="getDays >=1 && coupon.start_date && coupon.end_date">{{getBaseDate(coupon.start_date, '.')}}至{{getBaseDate(coupon.end_date, '.')}}</div>
            <count-down v-else :haveBg="true"  :endTime="coupon.end_date"></count-down>
            <template v-if="status === 'normal'">
              <div class="tips" v-if="isInvalid">
                未生效
              </div>
              <div class="tips" v-else-if="getDays>=1 && getDays<7">
                还剩{{Math.ceil(getDays)}}天
              </div>
            </template>
          </div>
          <!-- 已使用或已过期 -->
          <div class="coupon-time" v-else>
            <div class="time">{{getBaseDate(coupon.expiry_date, '.')}} {{statusDesc}}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- <coupon-desc-dialog :show.sync="showCouponDescDialog" :coupon="coupon"></coupon-desc-dialog> -->
  </div>
  </template>
  
  <script>
  import sensorsdata from 'sa-sdk-javascript';
  import CountDown from '@/components/count-down.vue';
  import dateUtils from '@/libs/date-util';
  // import CouponDescDialog from './coupon-desc-dialog.vue';
  import CouponItemLeft from './components/coupon-item-left.vue';
  import utils from '@/libs/utils';
  
  export default {
    components: {
      // CouponDescDialog,
      // CouponItem,
      CouponItemLeft,
      CountDown,
    },
    props: {
      coupon: Object,
    },
    data() {
      return {
        showCouponDescDialog: false,
        showCountDown: true,
      };
    },
    computed: {
      // 优惠卷状态
      status() {
        if (this.coupon.status === 1) { // 已使用
          return 'used';
        } else if (this.coupon.status === 0 && this.coupon.remaining_seconds <= 0) { // 未使用并且过期
          return 'expired';
        }
        return 'normal';
      },
      statusDesc() {
        let desc = '';
        desc = this.status === 'used' ? '已使用' : '';
        desc = this.status === 'expired' ? '已过期' : '';
        return desc;
      },
      getDays() {
        return utils.getDaysDifference(new Date(), this.coupon.end_date);
      },
      // 是否未生效
      isInvalid() {
        if (this.coupon.start_date) {
          const date = new Date(this.coupon.start_date);
          const today = new Date();
          return date.getTime() > today.getTime();
        }
        return false;
      },
      // 当前优惠券的描述，还剩几天
      couponExpiryDesc() {
        if (!this.coupon.end_date) return '';
        const dateObj = new Date(this.coupon.end_date);
        const today_string = dateUtils.getBaseDate(new Date());
        const today = new Date(today_string);
        let res_string;
        const remainder = Math.floor(Math.abs((dateObj - today) / (24 * 60 * 60 * 1000)));
        if (remainder > 0 && remainder <= 1) {
          const res_day = remainder + 1;
          res_string = `还剩${res_day}天`;
        } else if (remainder === 0) {
          res_string = '今天过期';
        } else {
          res_string = '';
        }
        return res_string;
      },
    },
    methods: {
      getBaseDate: dateUtils.getBaseDate,
      handleShowDescPopup(e) {
        sensorsdata.quick('trackHeatMap', e.target);
        this.showCouponDescDialog = true;
      },
    },
  };
  </script>
  
  <style lang="less" scoped>
  .coupon-item{
    width: 342px;
    height: 85px;
    background: url(../../../../assets/imgs/new-user/coupon-bg.png) no-repeat center / 100% 100%;
    line-height: 1;
    &.used{
      background: url(../../../../assets/imgs/new-user/coupon-used-bg.png) no-repeat center / 100% 100%;
      .coupon-reach-reduce{
        color: #91999F !important;
      }
    }
    &.expired{
      background: url(../../../../assets/imgs/new-user/coupon-invalid-bg.png) no-repeat center / 100% 100%;
      .coupon-reach-reduce{
        color: #91999F !important;
      }
    }
  
    .coupon-item-body{
      width: 100%;
      height: 100%;
      display: flex;
      .body-left{
        flex-shrink: 0;
        width: 97px;
        height: 100%;
        padding-left: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        .cash-reduce-box{
          display: flex;
          align-items: baseline;
          color: #fff;
          font-weight: 600;
          .icon{
            font-size: 15px;
          }
          .price{
            // letter-spacing: 0.8px;
            font-size: 34px;
          }
        }
      }
      .body-right{
        flex-grow: 1;
        overflow: hidden;
        height: 100%;
        padding: 14px 14px 14px 20px;
        .coupon-info{
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .coupon-reach-reduce{
            color: #2F333D;
            font-size: 14px;
          }
          .coupon-desc{
            display: flex;
            align-items: center;
            margin-top: 8px;
            .text{
              color: #91999F;
              font-size: 12px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .desc-tips{
              cursor: pointer;
              flex-shrink: 0;
              margin-left: 6px;
              background: url(../../../../assets/imgs/new-user/icon-tips.png) no-repeat center / 100% 100%;
              width: 16px;
              height: 16px;
            }
          }
          .coupon-time{
            margin-top: 6px;
            display: flex;
            align-items: center;
            .time{
              color: #91999F;
              font-size: 12px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .tips{
              flex-shrink: 0;
              margin-left: 4px;
              height: 16px;
              padding: 0 4px;
              background:#FFF4F4;
              border-radius: 9px;
              color: #FF6464;
              font-size: 12px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
        }
      }
    }
  
  }
  
  </style>
  


// WEBPACK FOOTER //
// src/components/activity/coupon-item/coupon-common-item/coupon-common-item.vue